import React from "react";
import { Link } from 'react-router-dom';
import { useRef, useState, useEffect, useContext } from "react";
import { useAuth } from "../context/AuthProvider.js";
import { Row, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { parseJwt } from "../utils/index.js";
import { getFromLS, setToLS } from "../utils/storage";
import * as Icon from "react-bootstrap-icons";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from "react-toastify";
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
import "./login.css";
import Carousel from 'react-bootstrap/Carousel';

function NewLogin() {
  let navigate = useNavigate();
  const auth = useAuth();

  const [username, setUser] = useState("");
  const [password, setPwd] = useState("");
  const [otp, setOtp] = useState("");
  const [requestOtp, setRequestOtp] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [success, setSuccess] = useState(false);
  const [activeFeatures, setActiveFeatures] = useState([]);
  const [rememberMe, setRememberMe] = useState(false);



  const signin = async (e) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_BASE_URI}/workflow/authenticate/`;


    const hashedPassword = CryptoJS.SHA256(password).toString();
    console.log(hashedPassword)

    fetch(url, {
      method: "POST",
      body: JSON.stringify({ Username: username, Password: hashedPassword }),

      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
      .then(response => response.json())
      .then(data => {
        if (data.success == false) {
          setErrMsg(data.message);
          toast.error(data.message, {
            position: "bottom-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "toastify-color-error",
          })
          return;
        }



        localStorage.setItem("token", data.Token);
        let firmId = parseJwt(data.Token).FirmId;
        localStorage.setItem("firmId", firmId);
        localStorage.setItem("username", data.Username);
        localStorage.setItem("usertype", data.UserType);
        localStorage.setItem("firmname", data.FirmName);
        localStorage.setItem("sendto", data.SendTo);
        localStorage.setItem("firstname", data.FirstName);
        localStorage.setItem("lastname", data.LastName);
        if (data.UserType) {
          switch (data.UserType) {
            case 'Flow Builder':
              localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "myflows" : "myapps")
              break;

            case 'Analyst':
              localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "maintenancereport" : "myapps")
              break;

            case 'Firm Admin':
              localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "myflows" : "myapps")
              break;

            case 'Super Admin':
              localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "superadmin" : "superadmin")
              break;

          }
        }

        if (data.isMFARequired === 'N') {
          // console.log("mfa not req", requestOtp)
          handleSuccessfulLogin(data);
          setRequestOtp(false);
          return;
        }
        // Bypass OTP if "Remember Me" is selected
        const savedUsername = Cookies.get('username');

        if (savedUsername) {
          const savedPassword = Cookies.get('password');

          if (savedUsername !== username) {
            requestOtpFunction(data);
          }
          else if (savedUsername === username && savedPassword !== password) {
            Cookies.remove('password');
            requestOtpFunction(data);
          }
          else if (savedUsername === username && savedPassword === password) {
            handleSuccessfulLogin(data);
          }
        }
        else {
          // Request OTP after successful login
          requestOtpFunction(data);
        }
      })
      .catch(error => console.error("Error:", error));
  };

  const handleSuccessfulLogin = (data) => {
    setSuccess(true);
    auth.login(username);

    const payload = { Username: username };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(payload),
    };

    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/features/`,
      requestOptions
    )
      .then(result => result.json())
      .then(result => {
        setToLS("active-features", result.data.FeatureCode);
        setActiveFeatures(result.data.FeatureCode);
        setTimeout(() => {
          if (getFromLS('active-features').length > 0) {
            navigate("/dashboard", { replace: true });
          }
        }, 2000);
      })
      .catch(error => console.error("Error fetching features:", error));
  };

  const requestOtpFunction = (data) => {
    // API call to request OTP
    const url = `${process.env.REACT_APP_BASE_URI}/workflow/request_otp/`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${data.Token}` },
      body: JSON.stringify({ Username: username }),
    })
      .then(response => response.json())
      .then(otpData => {
        if (otpData.success) {
          setRequestOtp(true); // Show OTP input
        } else {
          toast.error(otpData.message);
        }
      })
      .catch(error => console.error("Error:", error));
  };

  const verifyOtp = (e) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_BASE_URI}/workflow/verify_otp/`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Username: username, otp: otp }),
    })
      .then(response => {
        // Check the response status before parsing
        if (response.status === 403) {
          return response.json().then(data => {
            toast.error(data.message || 'Invalid OTP. Please try again.');
            window.location.reload(); // Reload the page on 403 error
          });
        }
        return response.json(); // Parse the response if it's not a 403
      })
      .then(data => {
        if (data.success) {
          // Proceed with login
          if (rememberMe) {
            Cookies.set('username', username, { expires: 7 }); // Store for 7 days
            Cookies.set('password', password, { expires: 7 });
          } else {
            Cookies.remove('username');
            Cookies.remove('password');
          }
          handleSuccessfulLogin(data);
        } else {
          toast.error(data.message);
        }
      })
      .catch(error => console.error("Error verifying OTP:", error));
  };

  var [i, j, k] = [0, 0, 0];

  var txt = `CYGNUS\nACCOUNTING\nHUB\n`;
  var txt2 = `Integrations made easy \n`
  var txt3 = `For best experience please use Chrome, Firefox or Edge browser.`
  var speed = 200;
  var speed2 = 200;
  var speed3 = 100;

  const typeWriter = () => {
    if (window.location.pathname == "/login" && i < txt.length) {
      let text = txt.charAt(i);
      document.getElementById("text1").innerHTML += text === "\n" ? "<br/>" : text;
      i++;
      setTimeout(typeWriter, speed);
    }
    if (window.location.pathname == "/login" && i == txt.length && j < txt2.length) {
      let text2 = txt2.charAt(j);
      document.getElementById("text2").innerHTML += text2 === "\n" ? "<br/>" : text2;
      j++;
      setTimeout(typeWriter, speed2);
    }
    if (window.location.pathname == "/login" && j == txt2.length && k < txt3.length) {
      let text3 = txt3.charAt(k);
      document.getElementById("text3").innerHTML += text3 === "\n" ? "<br/>" : text3;
      k++;
      setTimeout(typeWriter, speed3);
    }
  }
  useEffect(() => {
    if (window.location.pathname == "/login") {
      typeWriter();
    }
  }, [window.location.pathname])

  function LoginCarousel() {
    return (
      <Carousel>
        <Carousel.Item interval={3000}>
          <div style={{ height: 500, width: 500 }}></div>
          <Carousel.Caption style={{ textAlign: "left" }}>
            <h1 style={{ color: "#fff" }}>CYGNUS ACCOUNTING HUB</h1><br />
            <h5 style={{ color: "#fff" }}>Integrations made easy</h5>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item interval={10000}>
          <img
            className="d-block w-200"
            src={require("../images/dashboard_logo.png")}
            alt="First slide"
          />
          <Carousel.Caption style={{ textAlign: "left" }}>
            <h1 style={{ color: "#fff" }}>CYGNUS ACCOUNTING HUB</h1><br />
            <h5 style={{ color: "#fff" }}>Integrations made easy</h5>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-200"
            src={require("../images/dashboard_logo.png")}
            alt="First slide"
          />
          <Carousel.Caption style={{ textAlign: "left" }}>
            <h1 style={{ color: "#fff" }}>CYGNUS ACCOUNTING HUB</h1><br />
            <h5 style={{ color: "#fff" }}>Integrations made easy</h5>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    );
  }


  return (
    <Row className="no-gutter" style={{ background: "var(--theme1_primary)", height: "100vh" }}>
      {/* <div class="coins-container">
        <div class="coin">$</div>
        <div class="coin">$</div>
        <div class="coin">$</div>
        <div class="coin">$</div>
        <div class="coin">$</div>
        <div class="coin">$</div>
        <div class="coin">$</div>
        <div class="coin">$</div>
        <div class="coin">$</div>
      </div> */}
      <div class="icons-container">
        <Icon.FileEarmarkText className={"icon"} />
        <Icon.Calculator className={"icon"} />
        <Icon.GraphUpArrow className={"icon"} />
        <Icon.Coin className={"icon"} />
        <Icon.FileEarmarkSpreadsheet className={"icon"} />
      </div>

      {/* <div class="icons-container">
        <Icon.FileEarmarkBarGraph className={"icon"} />
      </div> */}
      {/* <div class="ripple-container">
        <div class="ripple" style={{left: "50%", top: "50%"}}></div>
        <div class="ripple" style={{left: "40%", top: "60%", animationDelay: "1s"}}></div>
        <div class="ripple" style={{left: "60%", top: "40%", animationDelay: "2s"}}></div>
      </div> */}
      {/* <div class="file">
        <div class="ripple" style={{ left: "50%", top: "50%" }}><h3 style={{color: "white"}}>Powered by AI</h3></div>
        <div class="ripple" style={{ left: "40%", top: "60%", animationDelay: "1s" }}></div>
        <div class="ripple" style={{ left: "60%", top: "40%", animationDelay: "2s" }}></div>
      </div> */}
      <div className="login-left-container">
        {/* <LoginCarousel /> */}
        <span id='text1'></span>
        <span id='text2'></span>
        <span id='text3'></span>
        {/* <h1 style={{ color: "#fff" }}>CYGNUS ACCOUNTING HUB</h1><br />
        <h5 style={{ color: "#fff" }}>Integrations made easy</h5> */}
      </div>
      <div className="login-form-container">
        <div className="flex-row-center-start go-login" style={{ marginBottom: 10 }}>
          <img className="login-dashboard-logo" src={require("../images/dashboard_logo.png")} />
          <h5 className="gradient-text">Cygnus Accounting Hub</h5>
        </div>
        <div style={{ marginBottom: "10px" }}>
          {requestOtp ? <h6>Enter OTP</h6> : <div className="flex-column-start-start" style={{ color: "var(--theme1_primary)" }}><div><h3>Welcome</h3></div><div><p>Please login to enter <Icon.DoorOpenFill /></p></div></div>}
        </div>
        <Form onSubmit={requestOtp ? verifyOtp : signin}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label style={{ fontSize: 8, fontWeight: 500, marginBottom: 0 }}>User name</Form.Label>
            <Form.Control
              type="text"
              className="custom-input"
              placeholder="username"
              name="user"
              value={username}
              onChange={(e) => setUser(e.target.value)}
              disabled={requestOtp}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label style={{ fontSize: 8, fontWeight: 500, marginBottom: 0 }}>Password</Form.Label>
            <Form.Control
              type="password"
              className="custom-input"
              placeholder="Password"
              name="password"
              value={password}
              onChange={(e) => setPwd(e.target.value)}
              disabled={requestOtp}
            />
          </Form.Group>
          {requestOtp && (
            <div>
              <Form.Group className="mb-3" controlId="formBasicOtp">
                <Form.Label style={{ fontSize: 8, fontWeight: 500, marginBottom: 0 }}>OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter OTP"
                  name="otp"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Check
                  className="custom-input"
                  type="checkbox"
                  label="Remember Me"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
              </Form.Group>
            </div>
          )}
          <div className="flex-row-space-center" style={{ marginTop: 25 }}>
            <Button variant="primary" type="submit" className="custom-button">
              {requestOtp ? "Verify OTP" : "Sign In"}
            </Button>
            <div>
              <Link to="/forgot-password" style={{ color: "#007bff", textDecoration: "none" }}>Forgot Password?</Link>
            </div>
          </div>
          <div className="tos-text">
            By signing in, you agree to our <Link to="/terms-of-service" style={{ color: "#007bff", textDecoration: "none" }}>Terms of Service</Link>
          </div>
        </Form>
      </div>
    </Row>
  );
}

export default NewLogin;